import * as React from "react";

const GlobeIconSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <circle
      cx={16}
      cy={16}
      r={13}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
    />
    <path
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 16h26M16 3a13 13 0 0 0 0 26 13 13 0 0 0 0-26zM8 8a20 20 0 0 1 16 0M8 24a20 20 0 0 0 16 0"
    />
  </svg>
);

export default GlobeIconSVG;
